import { createStore, applyMiddleware, compose } from 'redux';
import { persistStore } from 'redux-persist';

import { createBlacklistFilter } from 'redux-persist-transform-filter';

import { persistReducer } from 'redux-persist';

import localForage from 'localforage';

import thunkMiddleware from 'redux-thunk';
import { apiMiddleware } from 'redux-api-middleware';

import rootReducer from './rootReducer';

// Never save keys related to the app lifetime API status
const saveSubsetBlacklistFilter = createBlacklistFilter('persistentSettings', [
  'pending',
  'fulfilled',
  'rejected',
  'apiLastLoaded',
  'apiLastSaved',
]);

// Only allow persisting config on the persistentSetting reducer and use the blacklist for specific keys within that reducer
const rootPersistConfig = {
  key: 'root',
  storage: localForage,
  whitelist: ['persistentSettings'],
  transforms: [saveSubsetBlacklistFilter],
};

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      trace: true,
    })
  : compose;

const enhancer = composeEnhancers(
  applyMiddleware(apiMiddleware, thunkMiddleware)
);

/**
 * configureStore uses the createStore method from redux to create a store for the Provider component
 * @param   {object} initialState Object containing the initial state of the Redux store
 * @returns {object}              Redux store object, containing dispatch, getState, subscribe and other methods
 */

export let fullStore = undefined;
export default function configureStore(initialState = {}) {
  // Note: only Redux >= 3.1.0 supports passing enhancer as third argument.
  // See https://github.com/rackt/redux/releases/tag/v3.1.0

  const persistedReducer = persistReducer(rootPersistConfig, rootReducer);
  fullStore = createStore(persistedReducer, initialState, enhancer);
  const persistor = persistStore(fullStore);
  return { store: fullStore, persistor };
}
